module.exports = require("@platform/front-types");